import { logout } from '@/api/authentication';
import { timeout } from '@/helpers/timeout';
import type { AppsUrls } from '@/plugins/env-urls/types';
import { defineStore } from 'pinia';

type Config = {
  mixpanel: string;
  mixpanel_proxy: string;
  environment: string;
  api_url: string;
  url_auth: string;
  url_admin_account: string;
  url_recruiter_account: string;
  url_report_manager: string;
  url_candidate_reports: string;
  url_manager_account: string;
  url_help: string;
  assets_url: string;
  assets_cdn_url: string;
  translation_url: string;
  onboarding_url: string;
  assessments_url: string;
  swipe_url: string;
  login_url: string;
  register_url: string;
  domain_cookies: string;
  public_url: string;
  axeptio_client_id: string;
  mapbox_access_token: string;
  apps_urls: AppsUrls;
  oauth_token: string;
};

type State = {
  env?: string;
  loading: boolean;
  currentLocale: string;
  drawer: boolean;
  notificationDrawer: boolean;
} & Config;

export const useGlobalStore = defineStore('global', {
  state: (): State => ({
    env: process.env.NODE_ENV,
    environment: '',
    mixpanel: 'development',
    mixpanel_proxy: '',
    loading: true,
    currentLocale: '',
    api_url: '',
    url_auth: '',
    url_admin_account: '',
    url_recruiter_account: '',
    url_report_manager: '',
    url_candidate_reports: '',
    url_manager_account: '',
    url_help: '',
    translation_url: '',
    assets_url: '',
    assets_cdn_url: '',
    login_url: '',
    register_url: '',
    onboarding_url: '',
    assessments_url: '',
    swipe_url: '',
    domain_cookies: '',
    drawer: false,
    notificationDrawer: false,
    mapbox_access_token: '',
    public_url: '',
    axeptio_client_id: '',
    oauth_token: '',
    apps_urls: {
      auth_url: '',
      admin_account: '',
      recruiter_account: '',
      candidate_reports: '',
      report_manager: '',
      manager_account: '',
      help: '',
    },
  }),
  actions: {
    async logout(ms = 0) {
      await logout();
      await timeout(ms);

      document.location.href = this.login_url;
    },
    setConfig(config: Config) {
      Object.assign(this, {
        ...config,
        apps_urls: {
          auth_url: config.url_auth,
          admin_account: config.url_admin_account,
          recruiter_account: config.url_recruiter_account,
          report_manager: config.url_report_manager,
          candidate_reports: config.url_candidate_reports,
          manager_account: config.url_manager_account,
          help: config.url_help,
        },
        oauth_token: config.oauth_token,
      });
    },
    setLoading(value: boolean) {
      this.loading = value;
    },
    setDrawer(status: boolean) {
      this.drawer = status;
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    setNotificationDrawer(status: boolean) {
      this.notificationDrawer = status;
    },
    toggleNotificationDrawer() {
      this.notificationDrawer = !this.notificationDrawer;
    },
  },
});
